<div>
    <img #gmap style="height: 250px; width: 100%; margin-bottom: 10px;" />
    <div style="position: relative;">
      <div class="location-info-header">
        <h2>{{ customer?.DeliveryAddressCustomerName }} </h2>
        @if(customer?.AxCustomerNo){
        <h2> ({{customer?.AxCustomerNo}}) </h2>
        }
      </div>
      <p>
        {{ customer?.DeliveryAddress }}<br />
        {{ customer?.DeliveryZipCode }} {{ customer?.DeliveryCity }}<br /><br />
        {{ customer?.Phone }}<br />
        <a href="mailto:{{ customer?.Email }}">{{ customer?.Email}}</a>
</div>
    </div>
